var _excluded = ["type"];

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import { _optionalChain } from '@sentry/utils';
import { defineIntegration, convertIntegrationFnToClass } from '@sentry/core';
var NodeType;

(function (NodeType) {
  NodeType[NodeType["Document"] = 0] = "Document";
  NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
  NodeType[NodeType["Element"] = 2] = "Element";
  NodeType[NodeType["Text"] = 3] = "Text";
  NodeType[NodeType["CDATA"] = 4] = "CDATA";
  NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));

function elementClassMatchesRegex(el, regex) {
  for (var eIndex = el.classList.length; eIndex--;) {
    var className = el.classList[eIndex];

    if (regex.test(className)) {
      return true;
    }
  }

  return false;
}

function distanceToMatch(node, matchPredicate) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var distance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  if (!node) return -1;
  if (node.nodeType !== node.ELEMENT_NODE) return -1;
  if (distance > limit) return -1;
  if (matchPredicate(node)) return distance;
  return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}

function createMatchPredicate(className, selector) {
  return function (node) {
    var el = node;
    if (el === null) return false;

    try {
      if (className) {
        if (typeof className === 'string') {
          if (el.matches(".".concat(className))) return true;
        } else if (elementClassMatchesRegex(el, className)) {
          return true;
        }
      }

      if (selector && el.matches(selector)) return true;
      return false;
    } catch (e2) {
      return false;
    }
  };
}

var DEPARTED_MIRROR_ACCESS_WARNING = 'Please stop import mirror directly. Instead of that,' + '\r\n' + 'now you can use replayer.getMirror() to access the mirror instance of a replayer,' + '\r\n' + 'or you can use record.mirror to access the mirror instance during recording.';
var _mirror = {
  map: {},
  getId: function getId() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return -1;
  },
  getNode: function getNode() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return null;
  },
  removeNodeFromMap: function removeNodeFromMap() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  },
  has: function has() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return false;
  },
  reset: function reset() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  }
};

if (typeof window !== 'undefined' && window.Proxy && window.Reflect) {
  _mirror = new Proxy(_mirror, {
    get: function get(target, prop, receiver) {
      if (prop === 'map') {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
      }

      return Reflect.get(target, prop, receiver);
    }
  });
}

function hookSetter(target, key, d, isRevoked) {
  var win = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window;
  var original = win.Object.getOwnPropertyDescriptor(target, key);
  win.Object.defineProperty(target, key, isRevoked ? d : {
    set: function set(value) {
      var _this = this;

      setTimeout(function () {
        d.set.call(_this, value);
      }, 0);

      if (original && original.set) {
        original.set.call(this, value);
      }
    }
  });
  return function () {
    return hookSetter(target, key, original || {}, true);
  };
}

function patch(source, name, replacement) {
  try {
    if (!(name in source)) {
      return function () {};
    }

    var original = source[name];
    var wrapped = replacement(original);

    if (typeof wrapped === 'function') {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __rrweb_original__: {
          enumerable: false,
          value: original
        }
      });
    }

    source[name] = wrapped;
    return function () {
      source[name] = original;
    };
  } catch (e2) {
    return function () {};
  }
}

if (!/[1-9][0-9]{12}/.test(Date.now().toString())) ;

function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
  if (!node) {
    return false;
  }

  var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
  if (!el) return false;
  var blockedPredicate = createMatchPredicate(blockClass, blockSelector);

  if (!checkAncestors) {
    var isUnblocked = unblockSelector && el.matches(unblockSelector);
    return blockedPredicate(el) && !isUnblocked;
  }

  var blockDistance = distanceToMatch(el, blockedPredicate);
  var unblockDistance = -1;

  if (blockDistance < 0) {
    return false;
  }

  if (unblockSelector) {
    unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
  }

  if (blockDistance > -1 && unblockDistance < 0) {
    return true;
  }

  return blockDistance < unblockDistance;
}

var cachedRequestAnimationFrameImplementation;

function getRequestAnimationFrameImplementation() {
  if (cachedRequestAnimationFrameImplementation) {
    return cachedRequestAnimationFrameImplementation;
  }

  var document = window.document;
  var requestAnimationFrameImplementation = window.requestAnimationFrame;

  if (document && typeof document.createElement === 'function') {
    try {
      var sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      var contentWindow = sandbox.contentWindow;

      if (contentWindow && contentWindow.requestAnimationFrame) {
        requestAnimationFrameImplementation = contentWindow.requestAnimationFrame;
      }

      document.head.removeChild(sandbox);
    } catch (e) {}
  }

  return cachedRequestAnimationFrameImplementation = requestAnimationFrameImplementation.bind(window);
}

function onRequestAnimationFrame() {
  return getRequestAnimationFrameImplementation().apply(void 0, arguments);
}

var CanvasContext = /* @__PURE__ */function (CanvasContext2) {
  CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
  CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
  CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
  return CanvasContext2;
}(CanvasContext || {});

var errorHandler;

function registerErrorHandler(handler) {
  errorHandler = handler;
}

var callbackWrapper = function callbackWrapper(cb) {
  if (!errorHandler) {
    return cb;
  }

  var rrwebWrapped = function rrwebWrapped() {
    try {
      return cb.apply(void 0, arguments);
    } catch (error) {
      if (errorHandler && errorHandler(error) === true) {
        return function () {};
      }

      throw error;
    }
  };

  return rrwebWrapped;
};
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */


var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'; // Use a lookup table to find the index.

var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);

for (var i = 0; i < chars.length; i++) {
  lookup[chars.charCodeAt(i)] = i;
}

var encode = function encode(arraybuffer) {
  var bytes = new Uint8Array(arraybuffer),
      i,
      len = bytes.length,
      base64 = '';

  for (i = 0; i < len; i += 3) {
    base64 += chars[bytes[i] >> 2];
    base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
    base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
    base64 += chars[bytes[i + 2] & 63];
  }

  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1) + '=';
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + '==';
  }

  return base64;
};

var canvasVarMap = new Map();

function variableListFor(ctx, ctor) {
  var contextMap = canvasVarMap.get(ctx);

  if (!contextMap) {
    contextMap = new Map();
    canvasVarMap.set(ctx, contextMap);
  }

  if (!contextMap.has(ctor)) {
    contextMap.set(ctor, []);
  }

  return contextMap.get(ctor);
}

var saveWebGLVar = function saveWebGLVar(value, win, ctx) {
  if (!value || !(isInstanceOfWebGLObject(value, win) || _typeof(value) === 'object')) return;
  var name = value.constructor.name;
  var list = variableListFor(ctx, name);
  var index = list.indexOf(value);

  if (index === -1) {
    index = list.length;
    list.push(value);
  }

  return index;
};

function serializeArg(value, win, ctx) {
  if (value instanceof Array) {
    return value.map(function (arg) {
      return serializeArg(arg, win, ctx);
    });
  } else if (value === null) {
    return value;
  } else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
    var name = value.constructor.name;
    return {
      rr_type: name,
      args: [Object.values(value)]
    };
  } else if (value instanceof ArrayBuffer) {
    var _name = value.constructor.name;
    var base64 = encode(value);
    return {
      rr_type: _name,
      base64: base64
    };
  } else if (value instanceof DataView) {
    var _name2 = value.constructor.name;
    return {
      rr_type: _name2,
      args: [serializeArg(value.buffer, win, ctx), value.byteOffset, value.byteLength]
    };
  } else if (value instanceof HTMLImageElement) {
    var _name3 = value.constructor.name;
    var src = value.src;
    return {
      rr_type: _name3,
      src: src
    };
  } else if (value instanceof HTMLCanvasElement) {
    var _name4 = 'HTMLImageElement';

    var _src = value.toDataURL();

    return {
      rr_type: _name4,
      src: _src
    };
  } else if (value instanceof ImageData) {
    var _name5 = value.constructor.name;
    return {
      rr_type: _name5,
      args: [serializeArg(value.data, win, ctx), value.width, value.height]
    };
  } else if (isInstanceOfWebGLObject(value, win) || _typeof(value) === 'object') {
    var _name6 = value.constructor.name;
    var index = saveWebGLVar(value, win, ctx);
    return {
      rr_type: _name6,
      index: index
    };
  }

  return value;
}

var serializeArgs = function serializeArgs(args, win, ctx) {
  return args.map(function (arg) {
    return serializeArg(arg, win, ctx);
  });
};

var isInstanceOfWebGLObject = function isInstanceOfWebGLObject(value, win) {
  var webGLConstructorNames = ['WebGLActiveInfo', 'WebGLBuffer', 'WebGLFramebuffer', 'WebGLProgram', 'WebGLRenderbuffer', 'WebGLShader', 'WebGLShaderPrecisionFormat', 'WebGLTexture', 'WebGLUniformLocation', 'WebGLVertexArrayObject', 'WebGLVertexArrayObjectOES'];
  var supportedWebGLConstructorNames = webGLConstructorNames.filter(function (name) {
    return typeof win[name] === 'function';
  });
  return Boolean(supportedWebGLConstructorNames.find(function (name) {
    return value instanceof win[name];
  }));
};

function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
  var handlers = [];
  var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);

  var _iterator = _createForOfIteratorHelper(props2D),
      _step;

  try {
    var _loop = function _loop() {
      var prop = _step.value;

      try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') {
          return "continue";
        }

        var restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function (original) {
          return function () {
            var _this2 = this;

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
              setTimeout(function () {
                var recordArgs = serializeArgs(args, win, _this2);
                cb(_this2.canvas, {
                  type: CanvasContext['2D'],
                  property: prop,
                  args: recordArgs
                });
              }, 0);
            }

            return original.apply(this, args);
          };
        });
        handlers.push(restoreHandler);
      } catch (e) {
        var hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
          set: function set(v) {
            cb(this.canvas, {
              type: CanvasContext['2D'],
              property: prop,
              args: [v],
              setter: true
            });
          }
        });
        handlers.push(hookHandler);
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();

      if (_ret === "continue") continue;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return function () {
    handlers.forEach(function (h) {
      return h();
    });
  };
}

function getNormalizedContextName(contextType) {
  return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}

function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
  var handlers = [];

  try {
    var restoreHandler = patch(win.HTMLCanvasElement.prototype, 'getContext', function (original) {
      return function (contextType) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        if (!isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
          var ctxName = getNormalizedContextName(contextType);
          if (!('__context' in this)) this.__context = ctxName;

          if (setPreserveDrawingBufferToTrue && ['webgl', 'webgl2'].includes(ctxName)) {
            if (args[0] && _typeof(args[0]) === 'object') {
              var contextAttributes = args[0];

              if (!contextAttributes.preserveDrawingBuffer) {
                contextAttributes.preserveDrawingBuffer = true;
              }
            } else {
              args.splice(0, 1, {
                preserveDrawingBuffer: true
              });
            }
          }
        }

        return original.apply(this, [contextType].concat(args));
      };
    });
    handlers.push(restoreHandler);
  } catch (e) {
    console.error('failed to patch HTMLCanvasElement.prototype.getContext');
  }

  return function () {
    handlers.forEach(function (h) {
      return h();
    });
  };
}

function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
  var handlers = [];
  var props = Object.getOwnPropertyNames(prototype);

  var _iterator2 = _createForOfIteratorHelper(props),
      _step2;

  try {
    var _loop2 = function _loop2() {
      var prop = _step2.value;

      if (['isContextLost', 'canvas', 'drawingBufferWidth', 'drawingBufferHeight'].includes(prop)) {
        return "continue";
      }

      try {
        if (typeof prototype[prop] !== 'function') {
          return "continue";
        }

        var restoreHandler = patch(prototype, prop, function (original) {
          return function () {
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }

            var result = original.apply(this, args);
            saveWebGLVar(result, win, this);

            if ('tagName' in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
              var recordArgs = serializeArgs(args, win, this);
              var mutation = {
                type: type,
                property: prop,
                args: recordArgs
              };
              cb(this.canvas, mutation);
            }

            return result;
          };
        });
        handlers.push(restoreHandler);
      } catch (e) {
        var hookHandler = hookSetter(prototype, prop, {
          set: function set(v) {
            cb(this.canvas, {
              type: type,
              property: prop,
              args: [v],
              setter: true
            });
          }
        });
        handlers.push(hookHandler);
      }
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _ret2 = _loop2();

      if (_ret2 === "continue") continue;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return handlers;
}

function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
  var handlers = [];
  handlers.push.apply(handlers, _toConsumableArray(patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win)));

  if (typeof win.WebGL2RenderingContext !== 'undefined') {
    handlers.push.apply(handlers, _toConsumableArray(patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win)));
  }

  return function () {
    handlers.forEach(function (h) {
      return h();
    });
  };
}

var r = "for(var t=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\",e=\"undefined\"==typeof Uint8Array?[]:new Uint8Array(256),n=0;n<64;n++)e[t.charCodeAt(n)]=n;var a=function(e){var n,a=new Uint8Array(e),s=a.length,r=\"\";for(n=0;n<s;n+=3)r+=t[a[n]>>2],r+=t[(3&a[n])<<4|a[n+1]>>4],r+=t[(15&a[n+1])<<2|a[n+2]>>6],r+=t[63&a[n+2]];return s%3==2?r=r.substring(0,r.length-1)+\"=\":s%3==1&&(r=r.substring(0,r.length-2)+\"==\"),r};const s=new Map,r=new Map;const i=self;i.onmessage=async function(t){if(!(\"OffscreenCanvas\"in globalThis))return i.postMessage({id:t.data.id});{const{id:e,bitmap:n,width:o,height:f,dataURLOptions:c}=t.data,g=async function(t,e,n){const s=t+\"-\"+e;if(\"OffscreenCanvas\"in globalThis){if(r.has(s))return r.get(s);const i=new OffscreenCanvas(t,e);i.getContext(\"2d\");const o=await i.convertToBlob(n),f=await o.arrayBuffer(),c=a(f);return r.set(s,c),c}return\"\"}(o,f,c),d=new OffscreenCanvas(o,f);d.getContext(\"2d\").drawImage(n,0,0),n.close();const u=await d.convertToBlob(c),h=u.type,w=await u.arrayBuffer(),l=a(w);if(!s.has(e)&&await g===l)return s.set(e,l),i.postMessage({id:e});if(s.get(e)===l)return i.postMessage({id:e});i.postMessage({id:e,type:h,base64:l,width:o,height:f}),s.set(e,l)}};";

function t() {
  var t = new Blob([r]);
  return URL.createObjectURL(t);
}

var CanvasManager = /*#__PURE__*/function () {
  function CanvasManager(options) {
    var _this3 = this;

    _classCallCheck(this, CanvasManager);

    this.pendingCanvasMutations = new Map();
    this.rafStamps = {
      latestId: 0,
      invokeId: null
    };
    this.frozen = false;
    this.locked = false;

    this.processMutation = function (target, mutation) {
      var newFrame = _this3.rafStamps.invokeId && _this3.rafStamps.latestId !== _this3.rafStamps.invokeId;
      if (newFrame || !_this3.rafStamps.invokeId) _this3.rafStamps.invokeId = _this3.rafStamps.latestId;

      if (!_this3.pendingCanvasMutations.has(target)) {
        _this3.pendingCanvasMutations.set(target, []);
      }

      _this3.pendingCanvasMutations.get(target).push(mutation);
    };

    var _options$sampling = options.sampling,
        sampling = _options$sampling === void 0 ? 'all' : _options$sampling,
        win = options.win,
        blockClass = options.blockClass,
        blockSelector = options.blockSelector,
        unblockSelector = options.unblockSelector,
        recordCanvas = options.recordCanvas,
        dataURLOptions = options.dataURLOptions,
        errorHandler = options.errorHandler;
    this.mutationCb = options.mutationCb;
    this.mirror = options.mirror;
    this.options = options;

    if (errorHandler) {
      registerErrorHandler(errorHandler);
    }

    if (options.enableManualSnapshot) {
      return;
    }

    callbackWrapper(function () {
      if (recordCanvas && sampling === 'all') _this3.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
      if (recordCanvas && typeof sampling === 'number') _this3.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, unblockSelector, {
        dataURLOptions: dataURLOptions
      });
    })();
  }

  _createClass(CanvasManager, [{
    key: "reset",
    value: function reset() {
      this.pendingCanvasMutations.clear();
      this.resetObservers && this.resetObservers();
    }
  }, {
    key: "freeze",
    value: function freeze() {
      this.frozen = true;
    }
  }, {
    key: "unfreeze",
    value: function unfreeze() {
      this.frozen = false;
    }
  }, {
    key: "lock",
    value: function lock() {
      this.locked = true;
    }
  }, {
    key: "unlock",
    value: function unlock() {
      this.locked = false;
    }
  }, {
    key: "initCanvasFPSObserver",
    value: function initCanvasFPSObserver(fps, win, blockClass, blockSelector, unblockSelector, options) {
      var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
      var rafId = this.takeSnapshot(false, fps, win, blockClass, blockSelector, unblockSelector, options.dataURLOptions);

      this.resetObservers = function () {
        canvasContextReset();
        cancelAnimationFrame(rafId);
      };
    }
  }, {
    key: "initCanvasMutationObserver",
    value: function initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
      this.startRAFTimestamping();
      this.startPendingCanvasMutationFlusher();
      var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
      var canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
      var canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);

      this.resetObservers = function () {
        canvasContextReset();
        canvas2DReset();
        canvasWebGL1and2Reset();
      };
    }
  }, {
    key: "snapshot",
    value: function snapshot(canvasElement) {
      var options = this.options;
      var rafId = this.takeSnapshot(true, options.sampling === 'all' ? 2 : options.sampling || 2, options.win, options.blockClass, options.blockSelector, options.unblockSelector, options.dataURLOptions, canvasElement);

      this.resetObservers = function () {
        cancelAnimationFrame(rafId);
      };
    }
  }, {
    key: "takeSnapshot",
    value: function takeSnapshot(isManualSnapshot, fps, win, blockClass, blockSelector, unblockSelector, dataURLOptions, canvasElement) {
      var _this4 = this;

      var snapshotInProgressMap = new Map();
      var worker = new Worker(t());

      worker.onmessage = function (e) {
        var data = e.data;
        var id = data.id;
        snapshotInProgressMap.set(id, false);
        if (!('base64' in data)) return;
        var base64 = data.base64,
            type = data.type,
            width = data.width,
            height = data.height;

        _this4.mutationCb({
          id: id,
          type: CanvasContext['2D'],
          commands: [{
            property: 'clearRect',
            args: [0, 0, width, height]
          }, {
            property: 'drawImage',
            args: [{
              rr_type: 'ImageBitmap',
              args: [{
                rr_type: 'Blob',
                data: [{
                  rr_type: 'ArrayBuffer',
                  base64: base64
                }],
                type: type
              }]
            }, 0, 0]
          }]
        });
      };

      var timeBetweenSnapshots = 1000 / fps;
      var lastSnapshotTime = 0;
      var rafId;

      var getCanvas = function getCanvas(canvasElement) {
        if (canvasElement) {
          return [canvasElement];
        }

        var matchedCanvas = [];
        win.document.querySelectorAll('canvas').forEach(function (canvas) {
          if (!isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) {
            matchedCanvas.push(canvas);
          }
        });
        return matchedCanvas;
      };

      var takeCanvasSnapshots = function takeCanvasSnapshots(timestamp) {
        if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
          rafId = onRequestAnimationFrame(takeCanvasSnapshots);
          return;
        }

        lastSnapshotTime = timestamp;
        getCanvas(canvasElement).forEach(function (canvas) {
          var id = _this4.mirror.getId(canvas);

          if (snapshotInProgressMap.get(id)) return;
          snapshotInProgressMap.set(id, true);

          if (!isManualSnapshot && ['webgl', 'webgl2'].includes(canvas.__context)) {
            var context = canvas.getContext(canvas.__context);

            if (_optionalChain([context, 'optionalAccess', function (_) {
              return _.getContextAttributes;
            }, 'call', function (_2) {
              return _2();
            }, 'optionalAccess', function (_3) {
              return _3.preserveDrawingBuffer;
            }]) === false) {
              context.clear(context.COLOR_BUFFER_BIT);
            }
          }

          createImageBitmap(canvas).then(function (bitmap) {
            worker.postMessage({
              id: id,
              bitmap: bitmap,
              width: canvas.width,
              height: canvas.height,
              dataURLOptions: dataURLOptions
            }, [bitmap]);
          }).catch(function (error) {
            callbackWrapper(function () {
              throw error;
            })();
          });
        });
        rafId = onRequestAnimationFrame(takeCanvasSnapshots);
      };

      rafId = onRequestAnimationFrame(takeCanvasSnapshots);
      return rafId;
    }
  }, {
    key: "startPendingCanvasMutationFlusher",
    value: function startPendingCanvasMutationFlusher() {
      var _this5 = this;

      onRequestAnimationFrame(function () {
        return _this5.flushPendingCanvasMutations();
      });
    }
  }, {
    key: "startRAFTimestamping",
    value: function startRAFTimestamping() {
      var _this6 = this;

      var setLatestRAFTimestamp = function setLatestRAFTimestamp(timestamp) {
        _this6.rafStamps.latestId = timestamp;
        onRequestAnimationFrame(setLatestRAFTimestamp);
      };

      onRequestAnimationFrame(setLatestRAFTimestamp);
    }
  }, {
    key: "flushPendingCanvasMutations",
    value: function flushPendingCanvasMutations() {
      var _this7 = this;

      this.pendingCanvasMutations.forEach(function (values, canvas) {
        var id = _this7.mirror.getId(canvas);

        _this7.flushPendingCanvasMutationFor(canvas, id);
      });
      onRequestAnimationFrame(function () {
        return _this7.flushPendingCanvasMutations();
      });
    }
  }, {
    key: "flushPendingCanvasMutationFor",
    value: function flushPendingCanvasMutationFor(canvas, id) {
      if (this.frozen || this.locked) {
        return;
      }

      var valuesWithType = this.pendingCanvasMutations.get(canvas);
      if (!valuesWithType || id === -1) return;
      var values = valuesWithType.map(function (value) {
        var type = value.type,
            rest = _objectWithoutProperties(value, _excluded);

        return rest;
      });
      var type = valuesWithType[0].type;
      this.mutationCb({
        id: id,
        type: type,
        commands: values
      });
      this.pendingCanvasMutations.delete(canvas);
    }
  }]);

  return CanvasManager;
}();

var CANVAS_QUALITY = {
  low: {
    sampling: {
      canvas: 1
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.25
    }
  },
  medium: {
    sampling: {
      canvas: 2
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.4
    }
  },
  high: {
    sampling: {
      canvas: 4
    },
    dataURLOptions: {
      type: 'image/webp',
      quality: 0.5
    }
  }
};
var INTEGRATION_NAME = 'ReplayCanvas';
/** Exported only for type safe tests. */

var _replayCanvasIntegration = function _replayCanvasIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _canvasOptions = {
    quality: options.quality || 'medium',
    enableManualSnapshot: options.enableManualSnapshot
  };
  var canvasManagerResolve;

  var _canvasManager = new Promise(function (resolve) {
    return canvasManagerResolve = resolve;
  });

  return {
    name: INTEGRATION_NAME,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setupOnce: function setupOnce() {},
    getOptions: function getOptions() {
      var quality = _canvasOptions.quality,
          enableManualSnapshot = _canvasOptions.enableManualSnapshot;
      return _objectSpread({
        enableManualSnapshot: enableManualSnapshot,
        recordCanvas: true,
        getCanvasManager: function getCanvasManager(options) {
          var manager = new CanvasManager(_objectSpread(_objectSpread({}, options), {}, {
            enableManualSnapshot: enableManualSnapshot,
            errorHandler: function errorHandler(err) {
              try {
                if (_typeof(err) === 'object') {
                  err.__rrweb__ = true;
                }
              } catch (error) {// ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
              }
            }
          }));
          canvasManagerResolve(manager);
          return manager;
        }
      }, CANVAS_QUALITY[quality || 'medium'] || CANVAS_QUALITY.medium);
    },
    snapshot: function snapshot(canvasElement) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var canvasManager;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _canvasManager;

              case 2:
                canvasManager = _context.sent;
                canvasManager.snapshot(canvasElement);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */


var replayCanvasIntegration = defineIntegration(_replayCanvasIntegration);
/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */
// eslint-disable-next-line deprecation/deprecation

var ReplayCanvas = convertIntegrationFnToClass(INTEGRATION_NAME, replayCanvasIntegration);
export { ReplayCanvas, replayCanvasIntegration };